import DOMPurify from 'dompurify';

export const DomPurifyHtml = ({ html, ...props }) => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
}